import React, { useState } from "react";
import json2mq from "json2mq";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import ApplyButton from "./ApplyButton";
import { useLocation } from "react-router-dom";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  container: {
    width: { xl: "90%", xs: "100%" },
    marginTop: "55px",
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    justifyContent: "space-evenly",
    alignItems: isMobile ? "center" : "space-evenly",
    paddingBottom: "130px",
  },
  course: {
    hidden: {
      display: "none",
    },
    height: isMobile ? "414px" : "507px",
    width: isMobile ? "297px" : { xl: "435px", lg: "370px", md: "300px" },
    padding: isMobile ? "20px 10px" : "0px 10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(to bottom, #23213f 0%, #03183d 100%)",
    borderRadius: "40px",
    marginTop: "55px",
    "&:hover": {
      background: isMobile ? "" : "#010e25",
    },
  },
  typography: {
    title: {
      color: theme.palette.white.main,
      fontFamily: theme.typography.montserrat.bold,
      fontSize: "30px",
      lineHeight: "1.15",
      width: isMobile ? "280px" : "fit-content",
      marginTop: isMobile ? "" : "10px",
    },
    description: {
      marginTop: "18.8px",
      color: theme.palette.white.main,
      fontFamily: theme.typography.montserrat.regular,
      fontSize: isMobile ? "22px" : "24px",
      lineHeight: isMobile ? "1.15" : "1.5",
      width: isMobile ? "280px" : { xl: "370px" },
    },
    question: {
      fontFamily: theme.typography.montserrat.bold,
      color: theme.palette.white.main,
      fontSize: "50px",
    },
  },
});

const Courses = () => {
  const isMobile = useMediaQuery("(max-width:1000px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const { pathname } = useLocation();
  const { intro, jsbc } = useTranslation(pathname, "Courses");
  //IMPORT sfbc in courses

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 700,
    })
  );
  const sm = useMediaQuery(
    json2mq({
      maxWidth: 899,
    })
  );
  const md = useMediaQuery(
    json2mq({
      maxWidth: 1100,
    })
  );
  const lg = useMediaQuery(
    json2mq({
      maxWidth: 1640,
    })
  );
  const xl = useMediaQuery(
    json2mq({
      minWidth: 1641,
    })
  );

  const stylesHelper = () => {
    if (xs) return { img: { height: "161.9px", marginTop: "10px" } };
    if (sm) return { img: { height: "161.9px", marginTop: "10px" } };
    if (md) return { img: { height: "192px", marginTop: "10px" } };
    if (lg) return { img: { height: "192px", marginTop: "10px" } };
    if (xl) return { img: { height: "192px", marginTop: "10px" } };
  };

  const Course = ({ img, title, description, hover }) => {
    const [isHover, setIsHover] = useState(false);
    function mouseEnter(e) {
      setIsHover(true);
    }
    function mouseLeave() {
      setIsHover(false);
    }
    return isMobile ? (
      <Box sx={classes.course}>
        <Box>
          <img src={img} alt="" style={stylesHelper() && stylesHelper().img} />
          <Typography sx={classes.typography.title}>{title}</Typography>
          <Typography sx={classes.typography.description}>
            {description}
          </Typography>
        </Box>
      </Box>
    ) : (
      <Box
        sx={classes.course}
        onMouseEnter={mouseEnter}
        onMouseLeave={mouseLeave}
      >
        <Box sx={[classes.hover, isHover && classes.course.hidden]}>
          <Typography sx={classes.typography.question}>{hover}</Typography>
        </Box>
        <Box sx={!isHover && classes.course.hidden}>
          <img src={img} alt="" style={stylesHelper() && stylesHelper().img} />
          <Typography sx={classes.typography.title}>{title}</Typography>
          <Typography sx={classes.typography.description}>
            {description}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={classes.container}>
      <Box>
        <Course
          img={intro.img}
          title={intro.title}
          description={intro.description}
          hover={intro.hoverText}
        />
        <ApplyButton
          background={"linear-gradient(105deg, #f32c4d, #d00e2e 100%);"}
          color={"#d00e2e"}
          pathname="/aplica/intro"
        />
      </Box>
      <Box>
        <Course
          img={jsbc.img}
          title={jsbc.title}
          description={jsbc.description}
          hover={jsbc.hoverText}
        />
        <ApplyButton
          background={"linear-gradient(105deg, #fbbf30, #eda135 100%);"}
          color={"#eda135"}
          pathname="/aplica/javascript"
        />
      </Box>
      {/* <Box>
        <Course
          img={sfbc.img}
          title={sfbc.title}
          description={sfbc.description}
          hover={sfbc.hoverText}
        />
        <ApplyButton
          background={"linear-gradient(105deg, #99cdea, #2894cf 100%);"}
          color={"#2894cf"}
          pathname="/aplica/salesforce"
        />
      </Box> */}
    </Box>
  );
};

export default Courses;
